import { Competence, ParsedCompetence } from './types';

const parseCompetence = (item: Competence): Readonly<ParsedCompetence> =>
  Object.freeze({
    id: item!.id || '',
    name: item!.name || '',
    image: item.image ? item.image!.big || item.image!.original : '',
    main: {
      description: item!.description || '',
      evaluationCompCriterion: item!.evaluation_comp_criterion || '',
    },
    sidebar: {
      compBlockId: item!.comp_block_id || '',
      creatorComp: item!.creator_comp || '',
      cisNumber: item!.cis_number || '',
    },
  });

export default parseCompetence;



// WEBPACK FOOTER //
// ./src/services/api/competences/utils/parseCompetence.ts